import { AxiosInstance } from 'axios';
import { ClaimUserEmailChangeInput, CreateUserEmailChangeInput } from './inputs';
import { UserEmailChangeRef } from './refs';

export default class UserEmailChange {
    private basePath = '/api/user-email-change';
    private http: AxiosInstance;

    constructor(http: AxiosInstance) {
        this.http = http;
    }

    // Create new user email change
    create = async (input: CreateUserEmailChangeInput): Promise<UserEmailChangeRef> => {
        const { data } = await this.http.post(`${this.basePath}/`, input);
        return data;
    };

    // Claim user password reset and update password
    claim = async (id: ID, input: ClaimUserEmailChangeInput): Promise<UserEmailChangeRef> => {
        const { data } = await this.http.post(`${this.basePath}/${id}/claim`, input);
        return data;
    };
}
